import { useSelector } from 'react-redux';


function selector(s) {
  return s.player;
}

export default function usePlayer() {
  return useSelector(selector);
}